import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { reportApi } from './../api/system/index'
import { isClient } from '@vueuse/core'

let startTime = new Date().getTime() // 初次进入页面的时间戳

let sleepTotal = 0 // 休眠时长

// 仅变量 用于记录值
let sleepTime = 0 // 记录休眠开始时间戳
let sleepDuration = 0 // 页面单次休眠时长

function getReportHeaders(
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
) {
  const operateTime = new Date().getTime() // 获取当前操作时间
  console.log('😄😄😄😄😄', new Date(startTime))
  const allStay = startTime ? operateTime - startTime - sleepTotal : 0 // 计算活跃停留时间

  const headers = {
    'page-code': to.meta.pageCode || 'PAGE-CODE-IS-NULL',
    'Operation-Timestamp': `${operateTime}`,
    'Operation-Stay':
      from.meta.name || from.meta.pageCode ? `${allStay}` : `${0}`,
    'Operation-Sleep':
      from.meta.name || from.meta.pageCode ? `${sleepTotal}` : `${0}`,
    'Operation-Type': 'ROUTE', // 操作类型
  }
  // 重置页面初次进入时间
  startTime = operateTime
  // 重置休眠时间
  sleepTotal = 0

  return headers
}
function cclog(str: string, color = 'red') {
  console.log(`%c${str}!`, `color: ${color}; font-size: 20px;`)
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'hidden') {
    console.log('😄😄😄😄😄 初次进入当前页面的时间', new Date(startTime))
    cclog('页面进入后台')
    // 浏览器进入后台 记录休眠时间戳
    sleepTime = new Date().getTime()
  } else {
    // 浏览器进入前台
    cclog('页面进入前台')
    // 浏览器被激活，计算休眠时长并更新总停留时长
    const now = new Date().getTime()
    // 本次页面休眠的时长
    sleepDuration = now - sleepTime

    cclog(`本次休眠时长：${sleepDuration}ms`, 'blue')

    // 记录休眠总时长
    sleepTotal += sleepDuration

    // 重置休眠时间戳
    sleepTime = 0
  }
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (isClient) {
    const reportHeaders = getReportHeaders(to, from)
    // 监听浏览器的可见性变化
    document.addEventListener('visibilitychange', handleVisibilityChange)
    try {
      reportApi(
        {
          fromCode: from.meta?.pageCode || null,
          status: 'OK',
          eventCode: 'MPERA' + '.PAGE_INFO',
          extensions: {
            ERA_FROM_PAGE_PARAMS: {
              SHOPID:
                from.path.indexOf('/store/') > -1 && from.params?.id
                  ? from.params?.id
                  : undefined,
            },
            ERA_TO_PAGE_PARAMS: {
              SHOPID:
                to.path.indexOf('/store/') > -1 && to.params?.id
                  ? to.params?.id
                  : undefined,
            },
          },
        },
        reportHeaders,
      )
    } catch (error) {
      // throw createError(error)
    }
  }
  // return 'Hello Nitro'
})
